


































import { Component, Vue, Watch, Ref } from 'vue-property-decorator';
import { LabelModule } from '@/store/modules/label';
import LabelClass from '@/model/LabelClass';
import { FormModel } from 'ant-design-vue';
type IForm = ILabel.IRequest.ICreateOrUpdateLabel;

@Component
export default class LabelModal extends Vue {
  @Ref() private readonly labelForm!: FormModel;
  private newLabel: LabelClass | null = null;
  private form: IForm = {
    name: '',
    isPubilc: false,
    color: '',
    comment: '',
    active: true,
  };
  private rules = {
    name: [{ required: true, message: () => this.$t('form.required'), trigger: 'blur'}],
    // comment: [{ required: true, message: () => this.$t('form.required'), trigger: 'blur'}],
  };

  get colorList() {
    return LabelModule.labelColors;
  }
  get labelModal() {
    return LabelModule.labelModal;
  }
  get currentLabelId() {
    return LabelModule.currentLabel?.id;
  }
  get title() {
    return this.labelModal.isCreate ? this.$t('label.createLabel').toString() : this.$t('label.editLabel').toString();
  }
  get visible(): boolean {
    return this.labelModal.visible;
  }
  set visible(val) {
    LabelModule.ToggleLabelModalVisible();
  }
  private selectColor(color: string) {
    this.form.color = color;
  }
  @Watch('currentLabelId', {immediate: true})
  private watchLabelId(newValue: IForm) {
    if (!this.labelModal.isCreate && newValue) {
      const modalInfo = LabelModule.currentLabel?.getUpdateInfo;
      if (!modalInfo) {
        return;
      }
      this.form = {
        name: modalInfo.name,
        isPubilc: modalInfo.isPubilc,
        color: modalInfo.color,
        comment: modalInfo.comment,
        active: modalInfo.active,
      };
    } else {
      this.newLabel = new LabelClass();
      const modalInfo = this.newLabel.getUpdateInfo;
      this.form = {
        name: modalInfo.name,
        isPubilc: modalInfo.isPubilc,
        color: modalInfo.color || this.colorList[0],
        comment: modalInfo.comment,
        active: modalInfo.active,
      };
    }
  }
  private handleOk() {
    this.labelForm.validate((valid) => {
      if (valid) {
        if (this.newLabel && this.labelModal.isCreate) {
          const newLabel = this.newLabel;
          newLabel.requestCreateLabel(this.form).then((res) => {
            LabelModule.ToggleLabelModalVisible();
            LabelModule.AddLabelToList(newLabel);
          }).catch((err) => {
            this.$message.warning(err);
          });
        } else {
          LabelModule.currentLabel?.requestUpdateLabel(this.form).then((res) => {
            LabelModule.ToggleLabelModalVisible();
          }).catch((err) => {
            this.$message.warning(err);
          });
        }
      } else {
        return false;
      }
    });
  }
  private handleCancel() {
    this.visible = false;
  }
}
